<div class="section-header">
    <span>User E-mail Template</span>
</div>
<form [formGroup]="form">
    <div class="form-field full-width">
        <mat-form-field class="lc-form-field" appearance="outline">
          <label>E-mail template</label>
          <mat-select (selectionChange)="onEmailTemplateSelect($event)" formControlName="laboratoryEmailTemplateName" #emailTemplateSelect (openedChange)="emailTemplateSelectToggled()">
            <mat-form-field class="form-field inner-mat-input lc-form-field" appearance="outline">
              <input matInput #emailTemplateSearch placeholder="Search..."  />
            </mat-form-field>
              <mat-select-trigger>
                  {{emailTemplateSelect.value}}
              </mat-select-trigger>
              <div class="overflow-list">
              <div *ngFor="let emailTemplate of emailTemplateList">
                <div [hidden]="emailTemplateSearch.value.length>2 && !isEmailTemplateInFilter(emailTemplate)">
                  <mat-option [value]="emailTemplate?.name">{{ displayEmailTemplate(emailTemplate) }}</mat-option>
                </div>
              </div>
              </div>
          </mat-select>
       </mat-form-field>
    </div>

    <div class="form-field full-width">
        <mat-form-field class="lc-form-field" appearance="outline">
            <label>Subject</label>
            <input matInput formControlName="subject">
        </mat-form-field>
    </div>
</form>

<div class="button-container">
    <button *ngIf="hasMaintainUsersRight" mat-stroked-button class="lc-stroked-button-no-margin lc-primary" (click)="saveDetails()"
        [disabled]="!canSave()">
        <mat-icon svgIcon="tick"></mat-icon>Save
    </button>
    <button mat-stroked-button class="lc-stroked-button-no-margin lc-primary" (click)="cancel()">
        <mat-icon svgIcon="close"></mat-icon>{{ labelForClose }}
    </button>
</div>